import $ from 'jquery';
import LP from '../0-lp';


LP.dlgTextBlockVisible = {
    dispatching: false,

    prepare: function (selector, params) {
        $(selector).click(function () {
            if (!$(this).is('[disabled]')) {
                LP.Dialog.open($.extend(params, {
                    name: 'textblockVisible',
                    ajax: $(this).attr('url'),
                    request: $(this).attr('url_params'),
                    title: this.title,
                    width: 750,
                    height: 500,
                    onLoad: LP.dlgTextBlockVisible.onLoad,
                    beforeSubmit: LP.dlgTextBlockVisible.beforeSubmit,
                    onClose: LP.dlgTextBlockVisible.onClose
                }));
            }
            return false;
        });
    },

    onLoad: function () {
        LP.filters.init({root: '#fs-textblock-visibility'});
    },

    onClose: function () {
        var itemId = $('#dlgTextblockId').val();
        window.Browser.send('backend/closeEditDialog/', 'itemId=' + itemId);
        return false;
    },

    beforeSubmit: function () {
        LP.filters.removeEmptyTerms($('#fs-textblock-visibility'));

        LP.Dialog.hideErrors();
        var result = LP.dlgTextBlockVisible.onSave(false);

        return result;
    },

    onSave: function (refresh) {
        var tabResult = false;
        var url = 'backend/saveTextblockTab/';
        var params = $('#textForm').serialize();
        if (refresh) {
            params = params + '&refresh=1';
        }

        window.Browser.send(
            url,
            params,
            function (json) {
                LP.Dialog.showError(json, $('.tabError', LP.Dialog.getInstance(), false));
                tabResult = true;
                return true;
            },
            function (json) {
                LP.Dialog.showError(json, $('.tabError', LP.Dialog.getInstance(), false));
                tabResult = false;
                return true;
            },
            false // send syncron!
        );

        return tabResult;
    }
};